import stateMachine from "../online_app/instances/state_machine"
import {MixinStateMachine} from "../../lib/mixins/stateable";
import {MixinEvents} from "../../lib/mixins/eventable";

export default class OnlineAppBase {

    constructor(props={}) {
        console.info(`[OnlineApp] Initialization properties`, props);

        this.env = (props.hasOwnProperty('window') ? props.window : null);
        this.doc = (props.hasOwnProperty('document') ? props.document : null);

        MixinEvents(this); // Allow `this` to fire/handle ComponentEvents events.

        MixinStateMachine(this); // Add the state machine management methods to `this`.
        this.setStateMachine(stateMachine); // Set `this.stateMachine`.
        this.setStateableObject(this); // Set the stateable object on the state machine to this OnlineApp instance.
    }

}